import { defineAsyncComponent } from 'vue';
import { pageResolver } from '@/core/app/componentResolver.service';
const FrontPage = defineAsyncComponent(() => import('./FrontPage.vue'));
const ContentPage = defineAsyncComponent(() => import('./ContentPage.vue'));
const ProductNotFoundPage = defineAsyncComponent(() => import('./ProductNotFoundPage.vue'));
const NewsArticlePage = defineAsyncComponent(() => import('./NewsArticlePage.vue'));
const NewsPage = defineAsyncComponent(() => import('./NewsPage.vue'));
const CampaignOverviewPage = defineAsyncComponent(() => import('./CampaignOverviewPage.vue'));
const BecomeACustomerPage = defineAsyncComponent(() => import('./become-a-customer/BecomeACustomerPage.vue'));
const BecomeASupplierPage = defineAsyncComponent(() => import('./become-a-supplier/BecomeASupplierPage.vue'));
const RackConfiguratorPage = defineAsyncComponent(() => import('@/project/app/client-pages/rack-configurator/RackConfiguratorPage.vue'));
const CustomerServiceHubPage = defineAsyncComponent(() => import('./CustomerServiceHubPage.vue'));
const CustomerServiceHubOrderOverviewPage = defineAsyncComponent(() => import('./CustomerServiceHubOrderOverviewPage.vue'));
const TermsAndConditionsPage = defineAsyncComponent(() => import('./TermsAndConditionsPage.vue'));

// Content pages
pageResolver.register('frontpage', FrontPage);
pageResolver.register('newsPage', NewsPage, { updateOnQueryChange: true });
pageResolver.register('campaigns', CampaignOverviewPage, { updateOnQueryChange: true });
pageResolver.register('newsArticlePage', NewsArticlePage);
pageResolver.register('contentPage', ContentPage);
pageResolver.register('termsAndConditionsPage', TermsAndConditionsPage);
pageResolver.register('product404Page', ProductNotFoundPage);
pageResolver.register('becomeACustomer', BecomeACustomerPage);
pageResolver.register('becomeASupplierPage', BecomeASupplierPage);
pageResolver.register('rackConfiguratorPage', RackConfiguratorPage);
pageResolver.register('customerServiceHubPage', CustomerServiceHubPage);
pageResolver.register('customerServiceHubOrderOverview', CustomerServiceHubOrderOverviewPage);

// No fallback - we prefer redirecting to 404
// Except in preview mode, just use contentpage
if (window.servercontext.preview) {
    pageResolver.registerFallback(ContentPage);
}
